//@ts-ignore
import agroyaar from "@assets/icons/menuIcons/agroyaar.svg"; //@ts-ignore
import pishkhan from "@assets/icons/menuIcons/dashboardicon.svg";//@ts-ignore
import planet from "@assets/icons/menuIcons/planeticon.svg";//@ts-ignore
import animalhusbandry from "@assets/icons/menuIcons/animalhusbandry.svg";//@ts-ignore
import greenhouse from "@assets/icons/menuIcons/greenhouse.svg";//@ts-ignore
import weatherStation from "@assets/icons/menuIcons/weathericon.svg";//@ts-ignore
import plan from "@assets/icons/menuIcons/planicon.svg";//@ts-ignore
import visit from "@assets/icons/menuIcons/visiticon.svg";//@ts-ignore
import edit from "@assets/icons/menuIcons/edit.svg";//@ts-ignore
import myusers from "@assets/icons/menuIcons/myusers.svg";//@ts-ignore
import productsaleable from "@assets/icons/menuIcons/productsaleable.svg";//@ts-ignore
import lab from "@assets/icons/menuIcons/labicon.svg";//@ts-ignore
import chillingrequirement from "@assets/icons/menuIcons/chillingrequirement.svg";//@ts-ignore
import weedless from "@assets/icons/menuIcons/weedlessicon.svg";//@ts-ignore
import plantdensity from "@assets/icons/menuIcons/Plantdensity.svg";//@ts-ignore
import user from "@assets/icons/menuIcons/User.svg";//@ts-ignore
import cultivar from "@assets/icons/menuIcons/cultivar.svg";//@ts-ignore
import harvest from "@assets/icons/menuIcons/harvest.svg";//@ts-ignore
import plantingDate from "@assets/icons/menuIcons/plantingDate.svg";//@ts-ignore
import waterSource from "@assets/icons/menuIcons/waterSource.svg";//@ts-ignore
import yieldGap from "@assets/icons/menuIcons/yieldGapIcon.svg";//@ts-ignore
import Zafaron from "@assets/icons/menuIcons/Zafaron.svg";//@ts-ignore
import Riskmanage from "@assets/icons/menuIcons/Riskmanage.svg";//@ts-ignore
import Poisoncalender from "@assets/icons/menuIcons/Poisoncalender.svg";//@ts-ignore
import Waterneed from "@assets/icons/menuIcons/Waterneed.svg";//@ts-ignore
import Agrocalculate from "@assets/icons/menuIcons/Agrocalculate.svg";//@ts-ignore
import experts from "@assets/icons/menuIcons/experts.svg";//@ts-ignore
import mechanization from "@assets/icons/menuIcons/mechanization.svg";//@ts-ignore
import operation from "@assets/icons/menuIcons/operation.svg";//@ts-ignore
import information from "@assets/icons/menuIcons/information.svg";//@ts-ignore
import debugprograms from "@assets/icons/menuIcons/debugprograms.svg";//@ts-ignore
import planingprograms from "@assets/icons/menuIcons/planingprograms.svg";//@ts-ignore
import farmershop from "@assets/icons/menuIcons/farmershop.svg";//@ts-ignore
import agrofarmer from "@assets/icons/menuIcons/agrofarmer.svg";//@ts-ignore
import agromeet from "@assets/icons/menuIcons/agromeet.svg";//@ts-ignore
import dashboardmanagement from "@assets/icons/menuIcons/dashboardmanagement.svg";//@ts-ignore
import Calculating from "@assets/icons/menuIcons/Calculating.svg";//@ts-ignore
import financialmanagement from "@assets/icons/menuIcons/financialmanagement.svg";//@ts-ignore
import wallet from "@assets/images/dashboard/Payment/wallet.png";//@ts-ignore
import leading from "@assets/icons/menuIcons/Raahbar.svg";//@ts-ignore
import CroppingPattern from "@assets/icons/menuIcons/cropping-pattern.svg";//@ts-ignore
import CroppingSuitability from "@assets/icons/menuIcons/cropping-suitability.svg";

export const menuIcons = (data: any) => {
  switch (data.name) {
    case "COUNTER":
      return pishkhan;

    case "FARMS":
      return planet;

    case "SEASONS":
      return planet;

    case "IRRIGATION_SOURCES":
      return waterSource;

    case "EXPERT_ACCESS":
      return experts;

    case "ANIMAL_HUSBANDRY":
      return animalhusbandry;

    case "GREENHOUSE":
      return greenhouse;

    case "WEATHER_STATIONS":
      return weatherStation;

    case "QUESTIONNAIRES":
      return plan;

    case "VISITS":
      return visit;

    case "EXPERIMENTS":
      return lab;

    case "YIELD_GAPS":
      return yieldGap;

    case "CHILLING_REQUIREMENTS":
      return chillingrequirement;

    case "CULTIVAR_RECOMMENDATIONS":
      return cultivar;

    case "HARVEST_DATE_RECOMMENDATIONS":
      return harvest;

    case "SOWING_DATE_RECOMMENDATIONS":
      return plantingDate;

    case "PRESCRIPTIONS":
      return weedless;

    case "CROPPING_PATTERN":
      return CroppingPattern;

    case "CROPPING_SUITABILITY":
      return CroppingSuitability;

    case "PLANTING_DENSITIES":
      return plantdensity;

    case "FIRST_SAFFRON_IRRIGATION_DATE_RECOMMENDATIONS":
      return Zafaron;

    case "RAINFED_RISK_MANAGEMENT":
      return Riskmanage;

    case "IRRIGATION_REQUIREMENTS":
      return Waterneed;

    case "AGRICULTURAL_CALCULATOR":
      return Agrocalculate;

    case "SPRAYING_CALENDAR":
      return Poisoncalender;

    case "PATHOLOGYـSOFTWARE":
      return debugprograms;

    case "PLANNINGـSOFTWARE":
      return planingprograms;

    case "AGRICULTURALـMARKET":
      return farmershop;

    case "LEADINGـFARMERSـNETWORK":
      return agrofarmer;

    case "KNOWLEDGEـSHARINGـNETWORK":
      return agromeet;

    case "DASHBOARDـMANAGEMENT":
      return dashboardmanagement;

    case "OPERATIONS":
      return operation;

    case "ORGANIZATION_INFORMATION":
      return information;

    case "MECHANIZATIONS":
      return mechanization;

    case "FARMERS":
      return user;

    case "MY_COLLEAGUES":
      return experts;

    case "INVOICES":
      return financialmanagement;

    case "UPDATE_CONTENT_PAGE":
      return edit;

    case "SALE_CROPS":
      return productsaleable;

    case "HUMANـRESOURCES":
      return myusers;

    case "FARM_ACCOUNTING":
      return Calculating;

    case "WALLETS":
      return wallet;

    case "AGRICULTURAL_INPUTS_SUPPLIERS_INQUIRY":
      return farmershop;

    case "FERTILIZER_VARIETY":
      return farmershop;

    case "AGRICULTURAL_INPUTS_SUPPLIERS_OFFERS":
      return farmershop;

    case "AGRICULTURAL_INPUT_SUPPLIERS":
      return farmershop;

    case "AGRICULTURAL_INPUTS_PURCHASE_REQUESTS":
      return farmershop;

    case "EXPERTS":
      return leading;

    case "OPERATION_REPORTS":
      return operation;

    default:
      return agroyaar;
  }
};
